import React from "react";
import Modal from "components/global/Modal";
import {
  ConfirmModalSecondaryButton,
  ConfirmModalDangerButton,
  ConfirmModalActionRow,
  ConfirmModalBodyText,
} from "components/global/styles/ConfirmModal.inline.styles";
type ConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: "default" | "danger";
  isLoading?: boolean;
};
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "default",
  isLoading = false,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    size="md"
    actions={
      <ConfirmModalActionRow>
        <ConfirmModalSecondaryButton onClick={onClose} type="button">
          {cancelLabel}
        </ConfirmModalSecondaryButton>
        <ConfirmModalDangerButton
          $tone={tone}
          disabled={isLoading}
          onClick={onConfirm}
          type="button"
        >
          {isLoading ? "Working..." : confirmLabel}
        </ConfirmModalDangerButton>
      </ConfirmModalActionRow>
    }
  >
    <ConfirmModalBodyText>{description}</ConfirmModalBodyText>
  </Modal>
);
export default ConfirmModal;
